import { generateTestId } from "@client-shared";

export const setProductMappingRowTestId = (identifier: string): string =>
  generateTestId("ProductMappingRow", identifier);
